import { ApiLocalStorage } from './ApiLocalStorage';

export function getButtonConfig() {
  const theme = ApiLocalStorage.get('theme') || {};
  return theme.components?.Button || null;
}

export function getButtonPadding() {
  const theme = ApiLocalStorage.get('theme') || {};
  const designTokens = theme.designTokens || {};
  
  // Retorna diretamente o valor do designTokens
  return designTokens['button-padding-fml'] || '30px';
}

export function getButtonBoxShadow() {
  const theme = ApiLocalStorage.get('theme') || {};
  const designTokens = theme.designTokens || {};
  
  // Busca diretamente no designTokens
  return designTokens['button-box-shadow-fml'] || '0px 6px 0px rgba(0, 0, 0, 0.1019607843)';
}

export function getButtonStyles() {
  const theme = ApiLocalStorage.get('theme') || {};
  const designTokens = theme.designTokens || {};
  const config = getButtonConfig();
  
  const styles: any = { ...config };
  
  // Só adiciona padding se há configuração específica
  if (designTokens['button-padding-fml']) {
    styles.padding = designTokens['button-padding-fml'];
  }
  
  // Só adiciona boxShadow se há configuração específica
  if (designTokens['button-box-shadow-fml']) {
    styles.boxShadow = designTokens['button-box-shadow-fml'];
  }
  
  return styles;
} 